<template>
  <div>
    <label :for="idInner" v-if="libelleLong">
      <div class="d-flex mb-3">
        <div v-html="libelleLong"></div>
        <span class="ml-1 red--text" v-if="!optionel">*</span>
      </div>
    </label>

    <infobulle v-if="descriptionPopup" :descriptionPopup="descriptionPopup"> </infobulle>

    <v-textarea
      :id="idInner"
      :style="{ width: largeurMaxEnPx }"
      v-bind="$attrs"
      :value="value"
      :rules="memoRules"
      @input="handleInput"
      @blur="$emit('blur', $event)"
      :label="label"
      :rows="rows"
      :dense="isDense"
      :outlined="isOutlined"
    ></v-textarea>
  </div>
</template>

<script>
import ChampBase from "./mixins/ChampBase"
export default {
  mixins: [ChampBase],
  data() {
    return {
      largeurMax: 500
    }
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event)
    }
  },
  computed: {
    memoRules() {
      return [(v) => this.optionel || !!v || this.champObligatoireMessage]
    },
    rows() {
      return this.champ?.rows ?? 5
    }
  }
}
</script>

<style>
</style>